export const procurementEs = {
  originals: {
    history: 'Consultar historial de versiones',
    search: 'Buscar originales',
    sort: 'Orden',
    newest: 'Más recientes primero',
    oldest: 'Más antiguos primero',
    noResults: 'Ninguna versión coincide con la búsqueda. La versión actual sigue disponible.',
    current: 'Mostrar versión actual',
    xmlDownload: 'Descargar justificante XML',
    xmlChecksum: 'Huella XML',
    reviewedDownload: 'Descargar original revisado',
    revision: 'Versión del original',
    version: 'Versión {{number}}',
    previous:
      'Está viendo una versión anterior. La aprobación utiliza la versión actual indicada en la vista previa contable.',
    file: 'Nuevo archivo original',
    reason: 'Motivo de la sustitución',
    save: 'Guardar versión original',
    replace: 'Sustituir original',
    add: 'Añadir original',
    download: 'Descargar original',
    source: 'Origen',
    recorded: 'Archivado el',
    checksum: 'Huella SHA-256',
    retained:
      'Los originales anteriores se conservan. Sustituir un archivo devuelve la factura a revisión e invalida las vistas previas de aprobación existentes.',
    electronicImmutable:
      'El original de la factura electrónica importada permanece inalterado. Una factura electrónica corregida debe revisarse e importarse de nuevo.',
    legacy:
      'Este original procede del almacenamiento anterior. Su sustitución explícita archiva primero el archivo anterior como una versión independiente; la fecha de archivo no representa una fecha histórica de recepción.',
    downloadOnly:
      'Descargue este original de forma segura; este formato no dispone de vista previa integrada.',
    reasonRequired: 'Explique la sustitución (al menos 3 caracteres).',
    reasonInvalid: 'El motivo no puede superar los 500 caracteres.',
    fileRequired: 'Seleccione un archivo original.',
    loadError: 'No se pudo cargar el historial de originales.',
    invalidSource:
      'Falta el original o su huella o asignación no es válida. Compruebe el archivo original.',
    notEditable: 'No puede sustituirse el original de una factura aprobada o anulada.',
    immutable: 'Las versiones originales se conservan sin cambios.',
    privateSource:
      'Los originales de facturas recibidas son internos y no pueden enlazarse públicamente.',
    reviewed: 'Original revisado',
    sources: {
      MANUAL_UPLOAD: 'Carga manual',
      LEGACY_CAPTURE: 'Conservado del almacenamiento anterior',
      ELECTRONIC_IMPORT: 'Importación de factura electrónica',
    },
  },
  orderStatus: {
    DRAFT: 'Borrador',
    SENT: 'Enviado',
    CONFIRMED: 'Confirmado',
    PARTIALLY_RECEIVED: 'Parcialmente recibido',
    RECEIVED: 'Completamente recibido',
    BILLED: 'Facturado',
    CANCELLED: 'Cancelado',
  },
  receiptStatus: {
    DRAFT: 'Borrador',
    POSTED: 'Publicado',
    CANCELLED: 'Cancelado',
  },
  qualityStatus: {
    ACCEPTED: 'Aceptado',
    DAMAGED_REJECTED: 'Dañado / rechazado',
    UNDER_QUARANTINE: 'En cuarentena',
  },
  invoiceStatus: {
    DRAFT: 'En espera de revisión',
    MATCHED: 'Coincidente',
    DISCREPANCY: 'Discrepancia de precio',
    APPROVED_FOR_PAYMENT: 'Aprobado para pago',
    PAID: 'Pagado',
    CANCELLED: 'Cancelado',
  },
  matchStatus: {
    PERFECT_MATCH: 'Coincidencia perfecta',
    TOLERANCE_ACCEPTED: 'Dentro de la tolerancia',
    PRICE_MISMATCH: 'Desajuste de precio',
    QTY_MISMATCH: 'Desajuste de cantidad',
    MANUALLY_OVERRIDDEN: 'Aceptado manualmente',
  },
  orders: {
    invalidNumber: 'Introduzca un número válido; la cantidad debe ser mayor que 0.',
    invalidTax: 'Introduzca un tipo impositivo entre 0 y 100.',
    title: 'Órdenes de compra',
    subtitle: 'Crear, enviar y rastrear órdenes de proveedor.',
    cardTitle: 'Resumen de órdenes',
    cardDescription: 'Todas las órdenes de compra con estado de entrega y valor de la orden.',
    create: 'Nueva orden de compra',
    newReceipt: 'Registrar recepción de mercancías',
    searchPlaceholder: 'Buscar número de orden o proveedor',
    error: 'No se pudieron cargar las órdenes de compra.',
    emptyTitle: 'No se encontraron órdenes de compra',
    emptyHint: 'Cree una orden de compra para iniciar el proceso de adquisición.',
    columns: {
      number: 'Número de orden',
      supplier: 'Proveedor',
      orderDate: 'Fecha de la orden',
      delivery: 'Fecha de entrega',
      status: 'Estado',
      total: 'Valor de la orden',
      article: 'Artículo',
      quantity: 'Cantidad',
      unit: 'Unidad',
      price: 'Precio de compra',
      tax: '% de IVA',
      lineNet: 'Neto',
      freeText: 'Texto libre',
    },
    created: 'La orden de compra {{number}} ha sido creada.',
    saved: 'Orden de compra guardada.',
    loadError: 'No se pudo cargar la orden de compra.',
    newTitle: 'Nueva orden de compra',
    editorHint: 'Artículos, términos y dirección de entrega de la orden de compra.',
    pdf: 'Descargar PDF',
    send: 'Enviar por correo electrónico',
    confirm: 'Confirmación de la orden recibida',
    confirmed: 'La orden de compra ha sido marcada como confirmada.',
    cancel: 'Cancelar orden',
    cancelled: 'La orden de compra ha sido cancelada.',
    cancelTitle: '¿Cancelar la orden de compra {{number}}?',
    cancelDescription:
      'La orden de compra será cancelada permanentemente y ya no podrá ser editada después.',
    cancelReason: 'Motivo de cancelación',
    receiveGoods: 'Registrar recepción de mercancías',
    itemsTitle: 'Artículos',
    itemsHint: 'Artículos del proveedor con precios escalonados o artículos de texto libre.',
    articlePlaceholder: 'Buscar artículo',
    noSupplierProducts: 'No hay artículos asignados a este proveedor.',
    freeTextPlaceholder: 'Descripción del artículo',
    removeItem: 'Eliminar artículo',
    addItem: 'Agregar artículo',
    net: 'Neto',
    tax: 'IVA',
    gross: 'Bruto',
    headerTitle: 'Encabezado del pedido',
    headerHint: 'Proveedor, fechas y condiciones.',
    supplier: 'Proveedor',
    supplierPlaceholder: 'Buscar proveedor',
    noSuppliers: 'No se encontraron proveedores.',
    minimumOrderValue: 'Valor mínimo de pedido',
    deliveryTime: 'Plazo de entrega',
    days: '{{count}} días',
    expectedDelivery: 'Fecha de entrega prevista',
    paymentTerms: 'Términos de pago (días)',
    incoterms: 'Incoterms',
    storageArea: 'Área de almacenamiento objetivo',
    storageAreaHint: 'Se completa automáticamente al registrar la recepción de mercancías.',
    notes: 'Notas',
    email: {
      title: 'Enviar orden de compra',
      description: 'La orden está adjunta en PDF y el estado se establece como "Enviada".',
      to: 'Destinatario',
      subject: 'Asunto',
      body: 'Mensaje',
      submit: 'Enviar',
      sent: 'La orden de compra ha sido enviada.',
      defaultSubject: 'Orden de compra {{number}}',
      defaultBody:
        'Hola,\n\npor favor encuentre adjunta nuestra orden de compra {{number}}.\n\nSaludos cordiales',
    },
  },
  receipts: {
    warehouseRequired:
      'Seleccione el almacén de esta ubicación. Una etiqueta sola no identifica las existencias.',
    title: 'Recepción de mercancías',
    subtitle: 'Resumen de las entradas de mercancías registradas y abiertas.',
    cardTitle: 'Resumen de entradas de mercancías',
    cardDescription: 'Todas las entregas registradas con su referencia de orden de compra.',
    create: 'Registrar recepción de mercancías',
    searchPlaceholder: 'Número de recibo, orden o albarán',
    error: 'No se pudieron cargar las entradas de mercancías.',
    listEmptyTitle: 'Aún no hay entradas de mercancías',
    listEmptyHint: 'Registre una entrega para actualizar su inventario.',
    columns: {
      number: 'Número de recibo',
      supplier: 'Proveedor',
      order: 'Orden de compra',
      deliveryNote: 'Nota de entrega',
      date: 'Recibido el',
      status: 'Estado',
    },
    terminalTitle: 'Registrar recepción de mercancías',
    terminalSubtitle:
      'Escanee la orden, verifique las cantidades y registre el stock de manera vinculante.',
    selectOrder: 'Seleccionar orden de compra',
    selectOrderHint:
      'Escanee el número de orden o seleccione una de las órdenes de compra abiertas.',
    scanOrder: 'Escanear número de orden',
    scanPlaceholder: 'p.ej., EK-2026-0001',
    openOrders: 'Órdenes de compra abiertas',
    openOrdersPlaceholder: 'Seleccionar pedido',
    emptyTitle: 'Ningún pedido de compra seleccionado',
    emptyHint: 'Escanee el código de barras del albarán o seleccione un pedido de compra.',
    loadError: 'No se pudieron cargar los artículos del pedido.',
    positionsTitle: 'Artículos de {{number}}',
    nothingOpen: 'Este pedido de compra no tiene cantidades abiertas.',
    batchManaged: 'Gestión por lotes',
    open: 'Abierto: {{quantity}} {{unit}}',
    quantityReceived: 'Cantidad recibida',
    quantityInvalid: 'Por favor, ingrese una cantidad mayor que 0.',
    batchNumber: 'Número de lote',
    batchRequired: 'Se requiere un número de lote para artículos gestionados por lote.',
    expiryDate: 'Fecha de caducidad',
    expiryRequired: 'Por favor, ingrese una fecha de caducidad.',
    storageLocation: 'Ubicación de almacenamiento / estante',
    storageLocationPlaceholder: 'p. ej. A-03-12',
    quality: 'Calidad',
    deliveryNoteTitle: 'Nota de entrega',
    deliveryNoteHint: 'Registre el número del albarán y adjunte un escaneo o foto.',
    deliveryNoteNumber: 'Número de albarán',
    storageArea: 'Área de almacenamiento',
    notes: 'Notas',
    attachScan: 'Escanear o subir albarán',
    noScan: 'No se adjuntó ningún documento',
    blocked: '{{count}} artículo(s) todavía están incompletos.',
    ready: '{{count}} artículo(s) serán contabilizados.',
    submit: 'Contabilizar recibo de mercancías y actualizar stock',
    posted: 'Recibo de mercancías {{number}} fue contabilizado y el stock se actualizó.',
  },
  invoices: {
    metadataTitle: 'Editar datos contables: {{number}}',
    importedMetadataHint:
      'Esta factura electrónica conserva sus importes y líneas originales. Edite aquí recepción, prestación, vencimiento y datos contables.',
    metadataSaved: 'Datos contables guardados. La factura requiere otra revisión.',
    metadataSaveFailed: 'No se pudieron guardar los datos contables. Se conservan las entradas.',
    importedSourceLocked:
      'Los valores importados están protegidos. Edite los datos contables por separado; otro original requiere una nueva importación revisada.',

    validation: {
      summary: 'Revise los campos señalados. Se conservan sus entradas.',
      supplier: 'Seleccione un proveedor.',
      invoiceNumber: 'Introduzca un número de factura de 1 a 60 caracteres.',
      date: 'Introduzca una fecha de calendario válida.',
      currency: 'Introduzca un código monetario válido de tres letras, por ejemplo EUR.',
      rate: 'Introduzca un tipo de cambio positivo con un máximo de 10 decimales.',
      source: 'Introduzca una fuente verificable del cambio de 3 a 240 caracteres.',
      amount: 'Introduzca un importe válido con un máximo de 4 decimales.',
      quantity: 'Introduzca una cantidad positiva con un máximo de 6 decimales.',
      percent: 'Introduzca un porcentaje entre 0 y 100 con un máximo de 6 decimales.',
      days: 'Introduzca un número entero permitido de días de descuento.',
      description: 'Introduzca una descripción de 1 a 200 caracteres.',
      decimalHint: 'Separador decimal: punto o coma. No utilice separadores de miles.',
    },
    editTitle: 'Editar factura de proveedor',
    editSubmit: 'Guardar cambios',
    withoutOrder: 'Sin pedido',
    optionalOrder: 'Opcional. Al seleccionar un pedido se copian sus líneas.',
    invoiceReceivedDate: 'Factura recibida el',
    serviceDate: 'Fecha de prestación',
    accountingDates: 'Fechas contables y tipo de cambio',
    accountingDatesHint:
      'Las fechas contable y fiscal se comprueban al aprobar. El tipo contable no sustituye al tipo fiscal exigido legalmente.',
    captureLoadError: 'No se pudieron cargar las opciones de registro.',
    draftSaved:
      'El borrador {{number}} está guardado. Reintente la carga del original o abra el borrador.',
    retryUpload: 'Reintentar carga del original',
    openDraft: 'Abrir borrador',
    title: 'Facturas de proveedores',
    subtitle:
      'Monitorear acreedores por fecha de vencimiento y fecha límite de descuento por pronto pago.',
    cardTitle: 'Facturas entrantes',
    cardDescription: 'Todas las facturas de proveedores con estado de revisión y pago.',
    create: 'Registrar factura',
    createTitle: 'Registrar factura de proveedor',
    createDescription:
      'Registre una factura con o sin pedido y adjunte el original para su revisión.',
    created: 'Factura {{number}} ha sido registrada.',
    searchPlaceholder: 'Buscar número de factura o proveedor',
    error: 'No se pudieron cargar las facturas de proveedores.',
    emptyTitle: 'No se encontraron facturas de proveedores',
    emptyHint: 'Registrar una factura de proveedor para iniciar la revisión.',
    blocked: 'Pago bloqueado',
    order: 'Orden de compra',
    orderPlaceholder: 'Seleccionar pedido',
    number: 'Número de factura',
    invoiceDate: 'Fecha de la factura',
    discountPercent: '% de descuento por pronto pago',
    discountDays: 'Días de descuento',
    document: 'Documento de la factura (PDF o escaneo)',
    addItem: 'Agregar artículo',
    removeItem: 'Eliminar artículo',
    submit: 'Registrar factura',
    discountHint: 'Descuento por pronto pago {{percent}} % disponible por {{count}} días más',
    discountHint_one: 'Descuento por pronto pago {{percent}} % disponible solo hoy',
    discountGone: 'Período de descuento vencido',
    kpi: {
      open: 'Importe abierto',
      overdue: 'Vencido',
      discrepancy: 'Con discrepancia',
      discount: 'Descuento por expirar',
    },
    columns: {
      number: 'Número de factura',
      supplier: 'Proveedor',
      invoiceDate: 'Fecha de la factura',
      dueDate: 'Vence el',
      discount: 'Descuento en efectivo',
      status: 'Estado',
      gross: 'Bruto',
      description: 'Descripción',
      quantity: 'Cantidad',
      unitPrice: 'Precio unitario',
      taxRate: '% de IVA',
    },
  },
  match: {
    title: 'Conciliación de tres vías {{number}}',
    loadError: 'No se pudo cargar la conciliación de la factura.',
    run: 'Recalcular conciliación',
    clear: 'Todos los artículos coinciden.',
    discrepancies: '{{count}} artículo(s) difiere(n).',
    documentTitle: 'Factura del proveedor',
    documentError: 'No se pudo cargar el documento.',
    noDocument: 'No se adjuntó ningún documento',
    noDocumentHint: 'Suba la factura como PDF o escaneo para revisarla aquí.',
    upload: 'Subir documento',
    uploaded: 'El documento ha sido almacenado.',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    rotate: 'Rotar',
    reload: 'Recargar',
    tableTitle: 'Pedido / entrega / factura',
    counts:
      '{{matched}} exacto · {{tolerance}} dentro de la tolerancia · {{discrepancy}} desviándose',
    columns: {
      position: 'Artículo',
      description: 'Descripción',
      ordered: 'Pedido',
      delivered: 'Entregado',
      invoiced: 'Facturado',
      variance: 'Variación',
      status: 'Estado',
    },
    totalVariance: 'Variación total',
    approve: 'Aprobar para pago',
    approved: 'La factura ha sido aprobada para pago.',
    acceptTolerance: 'Aceptar tolerancia manualmente',
    override: {
      title: 'Aceptar variación manualmente',
      description:
        'La razón se almacena en el registro de coincidencias y en la pista de auditoría.',
      reason: 'Razón',
      submit: 'Aceptar variación',
      saved: 'La variación ha sido aceptada.',
    },
    complaint: {
      action: 'Enviar queja',
      title: 'Queja al proveedor',
      description: 'El mensaje se envía por correo electrónico y se registra.',
      to: 'Dirección de correo electrónico',
      subject: 'Asunto',
      body: 'Mensaje',
      submit: 'Enviar queja',
      sent: 'La queja ha sido enviada.',
      defaultSubject: 'Consultar respecto a la factura {{number}}',
      defaultBody:
        'Hola,\n\nmientras revisaba tu factura {{number}} encontramos una varianza de {{variance}} en comparación con el pedido de compra y la recepción de mercancías.\n\nPor favor revisa el caso y envíanos una factura corregida.\n\nAtentamente',
    },
  },
} as const;
